<form class="form-signin signin" [formGroup]="signinForm" (ngSubmit)="onSubmit($event)" autocomplete="off">
  <h4 >Premiere connexion
  </h4>
  <!-- <div class="alert alert-info" style="font-size: 0.8em;padding: 5px;"*ngIf="environment.env != 'extranet'" >Vous pouvez utiliser vos identifiants Windows</div> -->
  <div class="alert alert-info" style="font-size: 0.8em;padding: 5px; cursor: pointer"
>Renseignez votre adresse email. Vous recevrez un email permettant la création de votre compte.</div>

  <input type="text" class="form-control" name="pseudo" formControlName="username" placeholder="Email" required autofocus [ngClass]="{ 'is-invalid': submitted && f.username.errors }">
  <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
    <div *ngIf="f.username.errors.required">Email requis.</div>
  </div>

  <p class="alert-error" *ngIf="error"><i class="fas fa-exclamation-triangle icon-alert-error"></i> Vérifiez votre email.</p>


  <div class="col-12 text-center pt-4"><button class="btn btn-success" type="submit"  [disabled]="loading">
    <i class="fas fa-spinner fa-spin" *ngIf="loading"></i>&nbsp;<i class="fas fa-sign-in-alt"></i> Inscription	</button></div>

    <div *ngIf="error" class="alert alert-danger mt-3 mb-0">{{error}}</div>
    <div class="alert alert-info mt-3 mb-0" style="font-size: 0.8em;padding: 5px; cursor: pointer"
     (click)="goToLogin()">Vous avez déjà un compte ? <strong>Cliquez-ici</strong></div>
 
    <div class="col-12 text-center pt-4"><button class="btn btn-info" type="button" (click)="goBack()"><i class="fa fa-chevron-left"></i>
      Retour</button></div>
</form>
